import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "JUËN — KAPATTIK" },
      { name: "description", content: "JUËN — mekânımızı kapattık." },
    ],
  }),
  component: ClosedPage,
});

function ClosedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <h1
        className="text-[clamp(3rem,14vw,12rem)] font-bold uppercase leading-none tracking-tight text-foreground"
        style={{ fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' }}
      >
        KAPATTIK
      </h1>
    </div>
  );
}
